angular.module('b2bLoginApp').directive('siteRates', ['Rate', function (Rate) {
    return {
        restrict: 'A',
        scope: {
            siteId: '=',
            companyId: '='
        },
        templateUrl: 'areas/rates.html',
        controller: ["$scope", function ($scope) {
            Rate.query({siteId: $scope.siteId}, function (data) {
                $scope.siteRates = data.items;
            });
        }]
    };
}]);
